import { oneLine } from 'common-tags';
import React from 'react';
import Button from './Button';

type PrimaryButtonProps = {
  buttonText: string;
  className?: string;
  action: () => void;
};
type DialogProps = {
  title?: string;
  description: string;
  loading?: boolean;
  primaryButton: PrimaryButtonProps;
  secondaryButton?: PrimaryButtonProps;
};

const Dialog = ({ title, description, primaryButton, loading = false, secondaryButton }: DialogProps) => {
  return (
    <div className={oneLine`fixed z-99999 inset-0 overflow-y-auto`}>
      <div className={oneLine`flex items-center justify-center h-full pt-4 px-4 text-center sm:p-0`}>
        <div className={oneLine`fixed inset-0 transition-opacity`} aria-hidden="true">
          <div className={oneLine`absolute inset-0 bg-gray-500 opacity-75`}></div>
        </div>

        <span className={oneLine`hidden sm:inline-block sm:align-middle sm:h-screen`} aria-hidden="true">
          &#8203;
        </span>
        <div
          className={oneLine`inline-block align-bottom bg-dark-200 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full`}
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className={oneLine` p-4 sm:px-6 sm:flex sm:justify-center`}>
            {title && (
              <h3
                className={oneLine`text-lg w-full text-center leading-6 font-medium text-white`}
                id="modal-headline"
              >
                {title}
              </h3>
            )}
          </div>
          <div className={oneLine`bg-dark-200 text-dark-300 px-4 pt-0 `}>
            <div className={oneLine`sm:flex sm:items-start sm:justify-center`}>
              <div className={oneLine`mt-3 text-center sm:mt-0 sm:text-left`}>
                <div className="mt-2 w-full text-center">
                  <p className={oneLine`text-sm`} dangerouslySetInnerHTML={{ __html: description }} />
                </div>
              </div>
            </div>
          </div>

          {loading !== true ? (
            <div className={oneLine`px-4 py-5 sm:px-6 flex justify-center`}>
              {secondaryButton && secondaryButton.buttonText && (
                <Button
                  color="secondary"
                  onClick={secondaryButton.action}
                  className={`${secondaryButton.className} sm:w-full sm:mx-3 mr-4`}
                >
                  {secondaryButton.buttonText}
                </Button>
              )}

              <Button
                color="primary"
                fill="full"
                onClick={primaryButton.action}
                className={`${primaryButton.className} sm:w-full sm:mx-3`}
              >
                {primaryButton.buttonText}
              </Button>
            </div>
          ) : (
            <div className={oneLine`px-4 py-5 sm:px-6 flex justify-center`}>
              {secondaryButton && secondaryButton.buttonText && (
                <Button
                  color="secondary"
                  disabled={true}
                  onClick={() => {}}
                  className={`${secondaryButton.className} sm:w-full sm:mx-3 mr-4`}
                >
                  {secondaryButton.buttonText}
                </Button>
              )}

              <Button
                color="primary"
                fill="full"
                disabled={true}
                onClick={() => {}}
                className={`${primaryButton.className} sm:w-full sm:mx-3`}
              >
                {primaryButton.buttonText}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Dialog.defaultProps = {};

export default Dialog;
